// @flow

import _ from 'lodash';
import React, { PureComponent } from 'react';
import Translate from 'client/components/translate';
import GLOBALS from 'client/constants/globals';
import 'client/styles/blog.scss';
import 'client/styles/tax/faq.scss';
import faq from './taxesFaq';

const { taxHelpEmail } = GLOBALS;

type Props = {
  faqText: {
    askTade: string,
    headline: string,
  },
};

type States = {
  faqItems: Array<Object>,
};

class TaxFAQ extends PureComponent<Props, States> {
  constructor(props: Props) {
    super(props);

    this.state = {
      faqItems: _.sampleSize(faq, 2),
    };
  }

  render() {
    const { faqItems } = this.state;
    const { faqText = {} } = this.props;

    if (!faqItems || !faqItems.length) {
      return null;
    }
    return (
      <div className="tax-faq">
        <div className="flex-column margin-top-2">
          <h3 className="margin-bottom-2 text-center">
            <Translate fallback={faqText.headline} />
          </h3>
        </div>
        <div className="row items large-table">
          {faqItems.map(faqItem => (
            <div key={faqItem.q} className="td large-6 pad">
              <div className="text-center large-text-left">
                <h5
                  className=""
                  // eslint-disable-next-line react/no-danger
                  dangerouslySetInnerHTML={{
                    __html: faqItem.q,
                  }} />
                <p
                  className="pad-top-2"
                  // eslint-disable-next-line react/no-danger
                  dangerouslySetInnerHTML={{
                    __html: faqItem.a,
                  }} />
              </div>
              <div className="flex-row pad-top-2">
                <img src={faqItem.author.img} alt={faqItem.author.name} style={{ width: 52 }} />
                <div className=" pad-x" style={{ fontSize: '14px' }}>
                  <strong>{faqItem.author.name}</strong>
                  <br />
                  <span className="light">{faqItem.author.title}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="row contact text-center">
          <h5 style={{ marginBottom: 6 }}>
            <Translate fallback={faqText.askTade} />
          </h5>
          <a href={`mailto:${taxHelpEmail}`}>{taxHelpEmail}</a>
        </div>
      </div>
    );
  }
}

export default TaxFAQ;
